exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contents-table {\n  position: absolute;\n  padding: 2rem; }\n\n.contents-table.sticky {\n  position: fixed;\n  top: 0; }\n\n.contents-table {\n  list-style: none;\n  margin: 0; }\n\n.contents-table a {\n  border-radius: 4px;\n  display: block;\n  padding: 0.3rem 0.6rem;\n  color: #444;\n  text-decoration: none; }\n\n.contents-table a.active {\n  background-color: #000;\n  color: #fff; }\n\n.columnify > .table-column {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1 auto;\n          flex: 0 1 auto;\n  width: 220px; }\n\n.framed {\n  position: relative;\n  height: 400px;\n  overflow-y: auto;\n  border: 1px solid #e2e2e2;\n  border-radius: 2px;\n  padding: 25px; }\n\n.columnify {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.columnify > * {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n\n.columnify > *:not(:first-child) {\n  margin-left: 2rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/travis/build/zurfyx/angular-contents/example/app/scrolling-view-table.component.scss
// module id = ../../../../../example/app/scrolling-view-table.component.scss
// module chunks = main